import Vue from 'vue'
import ShipLoading from '@/components/ShipLoading.vue'

const LoadingConstructor = Vue.extend(ShipLoading)
let instance = null

function createInstance() {
  instance = new LoadingConstructor().$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
}

const shipLoading = {
  show({ message = 'Loading...', forbidClick = true } = {}) {
    if (!instance) createInstance()
    instance.message = message
    instance.forbidClick = forbidClick
    instance.visible = true
  },
  hide() {
    if (instance) instance.visible = false
  },
}

// 挂载到 Vue 原型
Vue.prototype.$shipLoading = shipLoading

export default shipLoading